import { render, staticRenderFns } from "./rpt-cases-flagged.vue?vue&type=template&id=1984377f&"
import script from "./rpt-cases-flagged.js?vue&type=script&lang=js&"
export * from "./rpt-cases-flagged.js?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports